module.exports = __webpack_public_path__ + "img/home22.6360ceb8.png";